import { useCallback } from 'react';
import { useToast } from '@/app/providers/ToastProvider';
import { DEFAULT_DATA, nameFromEmail } from '@/shared/constants/config';
import { THEMES } from '@/shared/constants/themes';

export function useSettings(data, save) {
  const toast = useToast();
  const safeData = data || DEFAULT_DATA;
  const stg = safeData.settings || DEFAULT_DATA.settings;

  const isDark = stg.darkMode || false;
  const t = isDark ? THEMES.dark : THEMES.light;
  const currency = stg.currency || '$';
  const budgetMode = stg.budgetMode || 'standard';
  const displayNames = stg.displayNames || {};
  const defaultPayment = stg.defaultPayment || 'Debit Card';

  const getDisplayName = useCallback(
    (email) => displayNames[email] || nameFromEmail(email),
    [displayNames]
  );

  const updateSettings = useCallback(
    (patch, { silent } = {}) => {
      save({ ...safeData, settings: { ...stg, ...patch } });
      if (!silent) toast.success('Settings saved');
    },
    [safeData, stg, save, toast]
  );

  return {
    settings: stg,
    isDark,
    t,
    currency,
    budgetMode,
    displayNames,
    defaultPayment,
    getDisplayName,
    updateSettings,
  };
}
